module.exports = __webpack_public_path__ + "static/life-30-d1f9c7060cefd508fd757a63b05f2573.jpg";